export const LIMITS = {
  MAX_ADDITIONAL_INFORMATIONS: 10,
  MAX_BINS: 300,
  MAX_CLUSTERS: 50,
  MAX_GIFTS: 100,
  MAX_PROMOTION_NAME_LENGTH: 150,
  MAX_DESCRIPTION_LENGTH: 10000,
  MAX_SHIPPING_METHODS: 100,
  MAX_SKUS: 200,
  MAX_PRODUCTS: 200,
  MAX_COLLECTIONS: 200,
  MAX_CATEGORIES: 200,
  MAX_BRANDS: 200,
  MAX_ZIP_CODE_RANGES: 50,
  MAX_PROGRESSIVE_DISCOUNT_BENEFIT: 10,
  MAX_MARKETING_TAGS: 100,
  MAX_AFFILIATES: 100,
  MAX_COUPONS_GROUP: 1000,
  MAX_COUPON_NAME: 300,
  MAX_SELLERS_RETURN: 500,
  MAX_AUDIENCES: 20,

  // All promotions except Regular and Campaign are variations of the buy together cause.
  // These promotions have smaller limits, named after the API fields used by RnB backend.
  MAX_BUY_TOGETHER_SKUS: 100,
  MAX_BUY_TOGETHER_COLLECTIONS: 10,
}
